module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Aarau-a02db4e130d4de0fd89af88b36af0c67.svg";